import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	netoChatOne: 3,
	clientChatOne: 4,
	dialogTwo: 5,
	win: 6,
}
export const Tema4SubtopicFiveActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema5], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema5 activity 1");
			ObserverEmitter.emit(EVENTS.tema4.subtopicFive.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicFive.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Uso de cupones." />
					<DialogBarNew
						dialog={
							"¡Excelente trabajo! Ahora, te guiaré a través de una compra utilizando un cupón."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 5: Sinergia"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.netoChatOne);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act1_a02)

						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.netoChatOne && (
				<>	<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.neto} alt="Neto" />
						</figure>
					</div>
					<DialogBarNew
						name="Neto"
						dialog={
							"Hola buen día, bienvenida. ¿En qué puedo ayudar?."
						}
						callback={() => {
							setUiToShow(steps.clientChatOne);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act1_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.clientChatOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full flex justify-center items-center">
						<figure className="w-[35%]">
							<img className="mx-auto" src={imgsTopic4.yolandaWithCoupon} alt="Yolanda" />
						</figure>
					</div>
					<DialogBarNew
						name="Yolanda"
						dialog={
							"Hola buen día. Quisiera llevar esto, tengo un cupón."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub05.sub5_act1_a04)
							setUiToShow(steps.dialogTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"Nuestra tienda ofrece cupones con promociones que puedes descargar. Solo tienes que escanear los productos y el código para hacer valida la promoción."
						}
						callback={() => {
							setUiToShow(steps.win);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Lleva a la práctica lo que has aprendido ya que estas acciones te permitirán crecer y destacarte en tu trabajo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema5,
								})
							);
							navigation("/home4/tema4/subtema5/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
